const irregularApplications = [
    {
        "uuid": "1",
        "appNo": "21122101",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "createdOn": "2021-11-10T00:00:00.000Z",
        "creator": "王小白",
        "inspectionYear": 110,
        "inspectionMonth": 1,
        "inspectionTiming": "Y",
        "description": "不定追說明......\n" +
            ".......\n" +
            "......",
        "inspectionItems": [
            {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
            {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
        ]
    }
]

export default irregularApplications;